/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Belief_Body_2Inputs */

const en_about_belief_body_2 = /** @type {(inputs: About_Belief_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That’s the kind of progress we care about. We start with a specific process, build around the tools your team uses and keep the people who do the work involved.`)
};

const lv_about_belief_body_2 = /** @type {(inputs: About_Belief_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tieši šāds progress mums ir svarīgs. Sākam ar konkrētu procesu, izmantojam komandas esošos rīkus un iesaistām cilvēkus, kas šo darbu dara.`)
};

/**
* | output |
* | --- |
* | "That’s the kind of progress we care about. We start with a specific process, build around the tools your team uses and keep the people who do the work involved." |
*
* @param {About_Belief_Body_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const about_belief_body_2 = /** @type {((inputs?: About_Belief_Body_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Belief_Body_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_about_belief_body_2(inputs)
	return en_about_belief_body_2(inputs)
});